export default {
  tag: 'p',
  format: `<p />`,
  sourcePipeline: (source: string) => source,
  componentFn: ({ node, ...props }: any) => {
    const element = props.children?.[0];
    const tagName = element?.props?.node?.tagName;
    if (
      [
        'toolcall',
        'stepprocess',
        'blockcollapse',
        'attachment',
        'schedulerform',
        'schedulertaskcard',
        'schedulerrunnotification',
      ].includes(tagName)
    ) {
      return element;
    }
    return <p {...props} />;
  },
};
